module.exports = __webpack_public_path__ + "img/arrow-down-blue.064467fe.svg";